import React, { useState, useEffect, useContext } from "react";
import { Card, Box, Grid, TextField, Chip , Button } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import moment from "moment";
import ApiService from "../../functions/apiService";
import MyTable from "../../components/Schedule/MyTable";
import EmptyState from "../../components/Error/EmptyState";
import AuthContext from '../../context/AuthContext';
import Modal from 'react-bootstrap/Modal';
import { Row , Col } from "react-bootstrap";
import ButtonTheme from "../../components/ThemeButton/ThemeButton";
import { toast } from "react-toastify";

const UserSwapReport = () => {
  const { user } = useContext(AuthContext);
  const [year, setYear] = useState(new Date());
  const selectedYear = moment(year).format('YYYY');
  const [year2, setYear2] = useState(new Date());
  const selectedYear2 = moment(year2).format('YYYY');
  const [swapRows, setSwapRows] = useState([]);
  const [swapErrorMessage, setSwapErrorMessage] = useState();
  const [swapBalanceRows, setSwapBalanceRows] = useState([]);
	const [show, setShow] = useState(false);
	const [selectedSwap , setSelectedSwap] = useState([])

  const detailsColumns = [
    {
      field: 'Shift_Date',
      headerName: 'Shift Date',
      width: 160,
      renderCell: (params) => {
        return moment(params.value).format('MM/DD/YYYY');
      },
    },
    {
      field: 'Shift_Code',
      headerName: 'Shift',
      width: 300,
      renderCell: (params) => {
        const status = params.value;
        return <Chip
          sx={{
            height: 'auto',
            '& .MuiChip-label': {
              display: 'block',
              whiteSpace: 'normal',
            },
          }}
          style={{
            textAlign: 'center',
            padding: '6px 0px',
            width: '60%',
            color: '#2E3238',
            backgroundColor: status === 2 ? 'rgba(255, 165, 0, 0.26)' : 'rgba(52, 152, 219, 0.16)',
            border: status === 2 ? '1px solid rgba(255, 165, 0, 0.28)' : '1px solid rgba(52, 152, 219, 0.2)'
          }}
          label={status === 2 ? 'Day' : status === 91 ? `${params?.row?.TempShiftType}` : 'Night'}
        />;
      },
    },
    { field: 'Request_By', headerName: 'Requested by', width: 220 },
    { field: 'Request_To', headerName: 'Requested to', width: 220 },
		{
      field: 'Cancel_swap',
      headerName: '',
			width : 200,
      renderCell: (params) => {
        return (
					params?.row?.canCancelSwap && 
						<Button
							variant="contained"
							onClick={() => {
								if(!params.row.requestedCancelSwap){
									setShow(true)
									setSelectedSwap(params?.row)
								}
							}}
							sx={{
								backgroundColor: 
									(params.row.requestedCancelSwap && params.row.requestedCancelSwapStatus == 'Requested') ? 'orange' : 
									(params.row.requestedCancelSwapStatus == 'DECLINED' && params.row.requestedCancelSwap) ? '#000000' : '#ff0000',
								color: (params.row.requestedCancelSwap && params.row.requestedCancelSwapStatus == 'Requested')  ? '#000000'
									: (params.row.requestedCancelSwapStatus == 'DECLINED' && params.row.requestedCancelSwap) ? '#ffffff'
								: '#ffffff',
								marginLeft:'10px',
								padding : '8px',
								boxShadow:'none',
								'&:hover': {
									backgroundColor: 
									(params.row.requestedCancelSwap && params.row.requestedCancelSwapStatus == 'Requested') ? 'orange' : 
									(params.row.requestedCancelSwapStatus == 'DECLINED' && params.row.requestedCancelSwap) ? '#000000' : '#E62719',
									boxShadow:'none',
								},
							}}
						>	{params.row.requestedCancelSwap ? params.row.requestedCancelSwapStatus : 'Cancel Swap'}
						</Button>
				);
      },
    },
  ];

  const balanceColumns = [
    {
      field: 'start_date',
      headerName: 'Date',
      width: 240,
      renderCell: (params) => {
        return `(${params.row.start_date}  to  ${params.row.end_date})`
      },
    },
    { field: 'name', headerName: 'Swaps with', width: 300 },
    {
      field: 'sent_count',
      headerName: 'Swaps Request',
      width: 210,
      renderCell: (params) => {
        return <p style={{ borderRadius: '20px', padding: '2px 8px', backgroundColor: '#ff0000', color: '#ffffff', marginTop: '18px' }}>
          {params.value}
        </p>
      },
    },
    {
      field: 'received_count',
      headerName: 'Swaps Done',
      width: 210,
      renderCell: (params) => {
        return <p style={{ borderRadius: '20px', padding: '2px 8px', backgroundColor: '#008000', color: '#ffffff', marginTop: '18px' }}>
          {params.value}
        </p>
      },
    },
    {
      field: 'swap_balance',
      headerName: 'Balances',
      width: 210,
      renderCell: (params) => {
        return <p style={{ borderRadius: '20px', padding: '2px 8px', backgroundColor: '#555555', color: '#ffffff', marginTop: '18px' }}>
          {params.value}
        </p>
      },
    },
  ];

  const getSwapDetails = () => {
    ApiService.get("/ot-swap-report/" + user.Emp_Code, {
      'year': selectedYear
    })
      .then(({ data }) => {

				const objectData = data?.data || {};
				const arrayData = Object.values(objectData); 

				const updatedRows = arrayData.map((item, index) => ({
					...item,
					id: index + 1 
				}));

				setSwapRows(updatedRows);
      })
      .catch((error) => {
        setSwapRows([]);
        if (error.response.status == 400 && error.response?.data?.message) {
          setSwapErrorMessage(error.response.data.message);
        }
        else {
          console.log(error, 'err')
        }
      });
  }

  const getSwapBalance = () => {
    ApiService.get("/ot-swap-balance-report/" + user.Emp_Code, {
      'year': selectedYear2
    })
      .then((data) => {
        const responseData = data?.data?.data;
        const updatedRows = [];
        Object.entries(responseData).forEach(([fromId, fromData]) => {
          const fromName = fromData.full_name;
          const swapWith = fromData.swap_with;
          const start_date = moment(fromData.start_date).format('MM/DD/YYYY');
          const end_date = moment(fromData.end_date).format('MM/DD/YYYY');

          Object.entries(swapWith).forEach(([toId, toData], index) => {
            updatedRows.push({
              id: index + 1,
              name: toData.full_name,
              start_date: start_date,
              end_date: end_date,
              sent_count: toData.sent_count,
              received_count: toData.received_count,
              swap_balance: toData.swap_balance,
            });
          });
        });
        setSwapBalanceRows(updatedRows)
      })
      .catch((error) => {
        console.log(error, 'err2')
      });
  }

  useEffect(() => {
    getSwapDetails()
  }, [year, selectedYear]);

  useEffect(() => {
    getSwapBalance()
  }, [year2, selectedYear2]);

	const handleSwapRequest = () => {
			const body = {
					"Shift_Date": selectedSwap?.Shift_Date,
					"Shift_Number": selectedSwap?.Shift_Number,
					"Shift_Code" : selectedSwap?.Shift_Code
			}
			ApiService.post('/request-cancel-swap' , body).then((data) => {
				  setShow(false)
					toast.success(data.message || 'Request Send Successfully')
					getSwapDetails()
			}).catch((error) => {
					toast.error(error?.data?.message)
			})
	}


  return (
    <>
      <Card className="shadow p-3 my-3">
        <div className="d-flex justify-content-between align-items-center mt-2">
          <h6 className="fs-5 fw-600">Swap Details</h6>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              label="Select Year"
              views={['year']}
              value={year}
              onChange={(newValue) => setYear(newValue)}
              renderInput={(params) => <TextField {...params} />}
            />
          </LocalizationProvider>
        </div>
        <Box className="mt-3">
          {swapRows.length > 0 ? (
            <MyTable
              rows={swapRows}
              columns={detailsColumns}
              checkboxSelection={false}
              useTopFilter={false}
            />
          ) : (
            // <Box className="p-4 my-3">
            //   <EmptyState text={swapErrorMessage} />
            // </Box>

						<div className='d-flex flex-column align-items-center justify-content-center' style={{ height: 200, width: "100%" }}>
                              <img src='/images/blur-logo.png' style={{ height: 100}} />
                              <span className='mt-4' style={{ color: '#555555' }}>
                                No Swap Details Found
                              </span>
                            </div>
          )}
        </Box>
      </Card>

      <Card className="shadow p-3 my-3">
        <div className="d-flex justify-content-between align-items-center mt-2">
          <h6 className="fs-5 fw-600 my-2">Swap Balances</h6>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              label="Select Year"
              views={['year']}
              value={year2}
              onChange={(newValue) => setYear2(newValue)}
              renderInput={(params) => <TextField {...params} />}
            />
          </LocalizationProvider>
        </div>
        <Box className="mt-3">
          {swapBalanceRows.length > 0 ? (
            <MyTable
              rows={swapBalanceRows}
              columns={balanceColumns}
              checkboxSelection={false}
              useTopFilter={false}
            />
          ) : (
         <div className='d-flex flex-column align-items-center justify-content-center' style={{ height: 200, width: "100%" }}>
                              <img src='/images/blur-logo.png' style={{ height: 100}} />
                              <span className='mt-4' style={{ color: '#555555' }}>
                                No Balances Found
                              </span>
                            </div>
          )}
        </Box>
      </Card>

			<Modal show={show} onHide={() => setShow(false)}>
				<Modal.Header closeButton>
					<Modal.Title>Cancel Swap</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div style={{ color: '#555555' , width: '80%'}}>
						Are you sure you want to request a cancellation for this swap ?
					</div>
					<Row>
						<Col md='auto'>
							<ButtonTheme type='submit' variant="filled" color='white' className='mt-4' onClick={() => setShow(false)}>
								Cancel
							</ButtonTheme>
						</Col>
						<Col md='auto'>
							<ButtonTheme type='submit' variant="filled" color='primary' className='mt-4' onClick={handleSwapRequest}>
								Submit
							</ButtonTheme>
						</Col>
					</Row>
				</Modal.Body>
			</Modal>
    </>
  )
}

export default UserSwapReport;